
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
import DefaultNavbar from "parts/Navbars/DefaultNavbar";
import DefaultFooter from "parts/Footers/DefaultFooter";
import FilledInfoCard from "parts/Cards/InfoCards/FilledInfoCard";

// Presentation page sections
import Counters from "pages/home/sections/Counters";
import Information from "pages/home/sections/Information";
import DesignBlocks from "pages/home/sections/DesignBlocks";
import Testimonials from "pages/home/sections/Testimonials";
import Features from "pages/home/sections/Featuring";
import Download from "pages/home/sections/Download";
import LogoImg from "assets/images/logo.png"
import { Helmet } from 'react-helmet';
// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgVideo from "assets/videos/mg.mp4";


function Home() {
  return (
    <>
      <Helmet>
      <title>HPTech Solutions - AI, Cyber Security & Digital Marketing</title>
      <meta name="description" content="HPTech Solutions offers cutting-edge AI, machine learning, cyber security, and digital marketing services to help businesses thrive in a digital world." />
      <meta name="keywords" content="AI services, machine learning, cyber security, digital marketing, HPTech Solutions" />
      <meta property="og:title" content="HPTech Solutions - Home" />
      <meta name="google-site-verification" content="VMTrsIOdLSnLwlGSpdcSmmYUdtchXvbdniUqfB3CKV8" />
      <meta property="og:description" content="Leading provider of AI, cyber security, and digital marketing services." />
      <meta property="og:image" content="https://www.hptechsolutions.com/images/home-banner.jpg" />
      <meta property="og:url" content="https://www.hptechsolutions.com" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="HPTech Solutions - Home" />
      <meta name="twitter:description" content="HPTech Solutions: AI, Cyber Security, and Digital Marketing solutions." />
      <meta name="twitter:image" content="https://www.hptechsolutions.com/images/home-banner.jpg" />
    </Helmet>
      <DefaultNavbar
        routes={routes}
        
        sticky
      />
     <MKBox
  minHeight="75vh"
  width="100%"
  sx={{
    display: "grid",
    placeItems: "center",
    position: "relative",
    overflow: "hidden",
  }}
>
  <video
    autoPlay
    loop
    muted
    playsInline
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      zIndex: -1,
    }}
  >
    <source src={bgVideo} type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <Container>
  <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
    {/* Logo Section */}
    <Grid item xs={12} mb={3} display="flex" justifyContent="center">
      <img 
        src={LogoImg} // Replace with the actual path to your logo
        alt="HP Tech Solutions Logo"
        style={{ maxWidth: '150px', height: 'auto' }} // Adjust size as needed
      />
    </Grid>

    {/* Main Title */}
    <MKTypography
      variant="h1"
      color="white"
      mt={3} // Add top margin to ensure space between logo and title
      mb={1}
      sx={({ breakpoints, typography: { size } }) => ({
        [breakpoints.down("md")]: {
          fontSize: size["3xl"],
        },
      })}
    >
      HP TECH SOLUTIONS
    </MKTypography>

    {/* Subtitle */}
    <MKTypography
      variant="body1"
      color="white"
      textAlign="center"
      px={{ xs: 6, lg: 12 }}
      mt={2} // Add some margin to the top of the subtitle
    >
      Empowering Your Digital Future with Expert App Development, &amp; Web Solutions, Cybersecurity, and SEO Excellence.
    </MKTypography>
  </Grid>
</Container>


</MKBox>

      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
        <Features />
        <Information />
        <DesignBlocks />
        
        <Container>
          <Grid container spacing={3}>
            
            <Grid item xs={12} lg={4}>
              <FilledInfoCard
                color="info"
                icon="flag"
                title="Trust"
                description="Crafting Cutting-Edge Mobile and Web Solutions from the Ground Up highlights the process of developing innovative, user-centric digital platforms. By combining the latest technologies with custom design and seamless functionality, organizations create powerful mobile and web solutions that enhance user experiences and drive business growth."
              
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <FilledInfoCard
                variant="gradient"
                color="info"
                icon="flag"
                title="Honesty"
                description="Turning Ideas into Powerful Digital Experiences focuses on transforming creative concepts into engaging, impactful digital solutions. By blending innovation, design, and technology, organizations can bring ideas to life, creating memorable user experiences that drive engagement, enhance brand value, and achieve business success.."
                
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <FilledInfoCard
                color="info"
                icon="flag"
                title="Loyalty"
                description="Equipping Businesses with Tools to Lead in the Digital Space focuses on providing organizations with the latest technologies and strategies to thrive in an increasingly digital world. By offering powerful tools for innovation, data management, and automation, businesses can stay ahead of the competition and drive sustainable growth."
              />
            </Grid>
          </Grid>
        </Container>
        <Testimonials />
        <Download />
        <MKBox pt={18} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                  Thank you for your support!
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  We deliver the best web products
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={5}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                <MKSocialButton
                  component="a"
                  href="https://twitter.com/intent/tweet?text=Check%20Material%20Design%20System%20made%20by%20%40CreativeTim%20%23webdesign%20%23designsystem%20%23mui5&amp;url=https%3A%2F%2Fwww.creative-tim.com%2Fproduct%2Fmaterial-kit-react"
                  target="_blank"
                  color="twitter"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-twitter" />
                  &nbsp;Tweet
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.facebook.com/sharer/sharer.php?u=https://www.creative-tim.com/product/material-kit-react"
                  target="_blank"
                  color="facebook"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-facebook" />
                  &nbsp;Share
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.pinterest.com/pin/create/button/?url=https://www.creative-tim.com/product/material-kit-react"
                  target="_blank"
                  color="pinterest"
                >
                  <i className="fab fa-pinterest" />
                  &nbsp;Pin it
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Home;
